module.exports = __webpack_public_path__ + "img/meditative.f6f818df.svg";